var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"box"},[_c('h2',[_vm._v(_vm._s(_vm.$t('activity-logs')))]),_c('activity-logs',{attrs:{"idUser":_vm.currentUser.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }